var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmrBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 7,
    fill: "#E5EEF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 10C21.4643 10 21.9286 10.4311 21.9925 10.893L22 11V14C22 15.1027 23.2816 15.9287 24.3605 15.9956L24.5 16H27C27.4643 16 27.9286 16.4311 27.9925 16.893L28 17V28.5C28 29.4412 27.5571 29.9394 26.6713 29.9948L26.5 30H13.5C12.5588 30 12.0606 29.5571 12.0052 28.6713L12 28.5V11.5C12 10.5588 12.4429 10.0606 13.3287 10.0052L13.5 10H21ZM23.3253 10.026L23.3778 10.065L27.935 14.622C27.9984 14.6853 28.0174 14.7806 27.9831 14.8634C27.9557 14.9297 27.8985 14.9774 27.8308 14.9938L27.7784 15H24.3273C23.6401 15 23.0748 14.4775 23.0069 13.808L23 13.6722V10.2199C23.0006 10.1306 23.0547 10.0504 23.1373 10.0165C23.1993 9.99114 23.2681 9.99554 23.3253 10.026Z",
    fill: "#4C88AB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmrBadge);
export default __webpack_public_path__ + "static/media/emr-badge.55310ec4.svg";
export { ForwardRef as ReactComponent };